import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=43c7885e&scoped=true&"
import script from "./Licenses.vue?vue&type=script&lang=js&"
export * from "./Licenses.vue?vue&type=script&lang=js&"
import style0 from "./Licenses.vue?vue&type=style&index=0&id=43c7885e&prod&lang=scss&"
import style1 from "./Licenses.vue?vue&type=style&index=1&id=43c7885e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c7885e",
  null
  
)

export default component.exports